/***
 *
 *   SKELETON
 *   Placeholder block for loading states.
 *   Ported from ui-reference/src/components/ui/skeleton.tsx.
 *
 *   PROPS
 *   className: sizing and shape, e.g. 'h-28 w-full rounded-lg'
 *
 **********/

import { cn } from 'components/lib';

export function Skeleton({ className, ...rest }) {
    return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...rest} />;
}
